import { fetchMaster, getMaster, putMaster } from "utils/api";

export const getPermissionTagList = async (params) => {
  return await getMaster("/permissiontaglist", {
    ...params,
  });
};

export const getRoleById = async (roleId) => {
  return await getMaster("/roles/" + roleId, {});
};

export const createRole = async (params) => {
  return await fetchMaster("/roles", {
    ...params,
  });
};

export const updateRole = async (roleId, params) => {
  return await putMaster("/roles/" + roleId, {
    ...params,
  });
};
